import { useCallback, useEffect, useState } from 'react';
import { RESPONSE_STATUS } from '../../constnats/general';
import { TaskStatusType, TaskExecutionDetailsType } from '../../schemas/task.schemas';
import TasksRepo from '../../utils/repository/tasksRepo/tasksRepo';

function useEntityTaskExecutions(entityId: number, statuses: TaskStatusType[]) {
    const [entityExecutions, setEntityExecutions] = useState<TaskExecutionDetailsType[]>([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const fetchEntityExecutions = useCallback(() => {
        setLoading(true);
        TasksRepo.getTaskExecutionsByEntity(entityId, page, statuses, (response) => {
            if (response.status === RESPONSE_STATUS.SUCCESS) {
                setEntityExecutions(response.data.content);
                setTotalPages(response.data.totalPages);
            }
            setLoading(false);
        });
    }, [entityId, page, statuses]);

    useEffect(() => {
        fetchEntityExecutions();
    }, [fetchEntityExecutions]);

    return { entityExecutions, loading, refetch: fetchEntityExecutions, page, setPage, totalPages };
}

export default useEntityTaskExecutions;
